/* global interpolate, gettext */

export const moveHelpTextToDragAndDrop = () => {
    const frames = document.querySelectorAll('.upload-files-frame')

    frames.forEach(frame => {
        const helpText = frame.querySelector('.help-text')
        const dropZone = frame.querySelector('.drag-and-drop .label')

        if (helpText && dropZone) {
            dropZone.appendChild(helpText)
        }
    })
}

export const initCharCounters = () => {
    const counters = document.querySelectorAll('.counter')

    counters.forEach(input => {
        const maxLength = parseInt(input.getAttribute('maxlength')) || 1024

        let display = input.nextElementSibling
        if (!display || !display.classList.contains('counter-remaining-chars')) {
            display = document.createElement('div')
            display.classList.add('counter-remaining-chars')
            input.insertAdjacentElement('afterend', display)
        }

        const updateCounter = () => {
            const remaining = maxLength - input.value.length
            display.textContent = interpolate(gettext('Remaining %(count)s characters'), { count: remaining }, true)
        }

        updateCounter()
        input.addEventListener('input', updateCounter)
    })
}

export const initFieldManager = () => {
    const managers = document.querySelectorAll('.field-manager')

    managers.forEach(manager => {
        const inputs = Array.from(manager.querySelectorAll('input'))
        const addBtn = manager.querySelector('.add-field')

        if (!addBtn || inputs.length < 2) return

        addBtn.addEventListener('click', (e) => {
            if (addBtn.classList.contains('disabled')) return e.preventDefault()

            const nextHidden = inputs.find(input => input.classList.contains('d-none'))

            if (nextHidden) {
                nextHidden.classList.remove('d-none')
                nextHidden.classList.add('d-block')

                const removeBtn = document.createElement('button')
                removeBtn.type = 'button'
                removeBtn.className = 'remove-field'
                removeBtn.setAttribute('aria-label', 'delete')

                removeBtn.addEventListener('click', () => {
                    nextHidden.classList.remove('d-block')
                    nextHidden.classList.add('d-none')
                    nextHidden.value = ''
                    removeBtn.remove()
                    addBtn.classList.remove('disabled')
                })

                nextHidden.insertAdjacentElement('afterend', removeBtn)
            }

            const hasMoreHidden = inputs.some(input => input.classList.contains('d-none'))
            if (!hasMoreHidden) addBtn.classList.add('disabled')
        })
    })
}

export const initFileInputReset = () => {
    const buttons = document.querySelectorAll('.file-input-reset')

    buttons.forEach(button => {
        const target = button.dataset.target
        if (!target) return

        const input = document.querySelector(`input.${target}`)
        if (!input) return

        button.classList.add('disabled')

        const updateButtonState = () => {
            if (input.value) {
                button.classList.remove('disabled')
            } else {
                button.classList.add('disabled')
            }
        }

        input.addEventListener('input', updateButtonState)

        button.addEventListener('click', (e) => {
            if (button.classList.contains('disabled')) {
                e.preventDefault()
                return
            }
            input.value = ''
            updateButtonState()

            const parent = input.closest('.upload-files-frame')
            if (parent) {
                const ul = parent.querySelector('ul.upload-file-names')
                if (ul) ul.innerHTML = ''
            }
        })
    })
}
